import React, { ReactNode } from "react";
import { View } from "./view";

export const Layout: React.FC<{ children: ReactNode }> = ({ children}) => {
  return <View>{children}</View>;
};
